import { render, staticRenderFns } from "./audiences-group-manage-append.vue?vue&type=template&id=28aadd5d&scoped=true&"
import script from "./audiences-group-manage-append.vue?vue&type=script&lang=js&"
export * from "./audiences-group-manage-append.vue?vue&type=script&lang=js&"
import style0 from "./audiences-group-manage-append.vue?vue&type=style&index=0&id=28aadd5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aadd5d",
  null
  
)

export default component.exports